// src/Components/Routes/ProtectedRoute.jsx
// SHARED - Used in both Front Office and Back Office

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Protected route that requires user to be authenticated
const ProtectedRoute = ({ children, adminRequired = false }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="route-loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // If user is not authenticated, redirect to login page
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If admin required but user is not admin, redirect to home page
  if (adminRequired && currentUser.role !== 'admin' && currentUser.role !== 'pharmacist') {
    return <Navigate to="/" replace />;
  }

  // If user is authenticated (and admin if required), render children
  return children;
};

export default ProtectedRoute;